import toast from "react-hot-toast";
import { httpRequest } from "src/services/httpRequest";

interface EmailTemplate {
  id?: string;
  templateName: string;
  subject: string;
  body: string;
  footer: string;
  attachments: File[];
}

export async function handleInsertTemplate(setLoading: (flag: boolean) => void, newTemplate: EmailTemplate, id: string) {
  setLoading(true)
  const response = await httpRequest(
    id ? 'PATCH' : 'POST',
    `/template_configuration/${id ? `update/${id}` : 'insert'}`,
    {
      "TemplateType": newTemplate?.templateName,
      "Subject": newTemplate?.subject,
      "TemplateBody": newTemplate.body,
      "TemplateFooter": newTemplate?.footer
    }
  );
  if (response?.status === 'success') {
    toast.success('The template has been create successfully.');
    setLoading(false);
  } else {
    toast.error(response?.message);
    setLoading(false);
  }
}

export async function handleGetAllTemplate(setLoading: (flag: boolean) => void, setTemplates: any) {
  setLoading(true)
  try {
    const response = await httpRequest('GET', '/template_configuration/get_all');
    if (response?.status === 'success') {
      const data = await response?.data;
      const template = data?.map((item: any) => {
        return {
          id: item?.ID,
          templateName: item?.TemplateType,
          subject: item?.Subject,
          body: item?.TemplateBody,
          footer: item?.TemplateFooter,
          attachments: [],
        };
      });
      setTemplates(template);
      setLoading(false)
    } else {
      if(response?.message) toast.error(response?.message);
      setLoading(false)
    }
  } catch (error) {
    toast.error('An error occurred while fetching permits');
  }

}

export async function handleDeleteTemplate(setLoading: (flag: boolean) => void, templateId: string, setTemplates: any) {
  setLoading(true);
  const response = await httpRequest(
    'DELETE',
    `/template_configuration/delete/${templateId}`
  );
  if (response.status === 'success') {
    setLoading(false);
    toast.success('Template deleted successfully.');
    handleGetAllTemplate(setLoading, setTemplates);
  } else {
    setLoading(false);
    toast.error(response?.message);
  }
}